<template>
  <div class="date-price-show">
    <span>{{formatDate}} </span>
    <span>({{formatDay}}) </span>
    <span class="price">￥：{{price}} </span>
  </div>  
</template>

<script>
export default {
  props:{
    date:String,
    price:String
  },
  computed:{
    formatDate(){
      return this.$moment(this.date).format('YYYY-MM-DD');
    },
    formatDay(){
      return this.$moment(this.date).format('dddd');
    }
  },
  created(){
  
  }
}
</script>

<style lang="scss" scoped>
  .date-price-show{
    background: #fff;
    border:1px solid #eee;
    padding: 5px 15px;
    .price{
      color:red;
    }
  }
</style>
